import { useAuth } from '@App/components/AuthProvider/auth-provider.context';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@nazka/nazka.mapframe.components';
import { useDispatch } from 'react-redux';

import { useOnClickOutside } from '@services/hooks.service'
import { setShowUserManagementModal } from '@App/pages/Admin/admin.slice';

import './account-menu.styl';

function AccountMenu({ setShowAccountModal, accountRef }) {
  const { logOut, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useOnClickOutside(accountRef, () => {
    setShowAccountModal(false);
  });

  return (
    <div className="account-menu">
      {/* <p className="account-menu__name">
        {user?.family_name && (<span>{`${user?.given_name} ${user?.family_name}`}</span>)}
      </p> */}
      <p className="account-menu__email">
        {user?.email}
      </p>
      {location.pathname === '/admin' && (
        <Button 
          className="account-menu__button"
          themeColor="secondary"
          onClick={() => dispatch(setShowUserManagementModal(true))}
          layout="outlined"
        >
          Gebruikersbeheer
        </Button>
      )}
      {user?.groups?.includes('employers') && location.pathname !== '/admin' && (
        <Button 
          className="account-menu__button"
          themeColor="secondary"
          onClick={() => {
            navigate('/admin');
            setShowAccountModal(false);
          }}
          layout="outlined"
        >
          Werkgeversportaal
        </Button>
      )}
      <Button 
        className="account-menu__button"
        themeColor="secondary"
        onClick={() => {
          logOut();
          setShowAccountModal(false);
        }}
      >
        Afmelden
      </Button>
    </div>
  );
}

export default AccountMenu;